
import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'

import * as colors from 'material-ui/styles/colors';

import moment from 'moment'

import * as commons from '../commons'
import * as actions from '../actions'

export function* handleSubHolidayClear(action) {

  const { form } = action.payload

  yield put(startSubmit(`systemControllMasterForm`))
  yield put(actions.reducerAppLoading(true))

  let newForm = {
    start: form.start ? moment(new Date(form.start)).format('YYYY/MM/DD'): "",
    end: form.end ? moment(new Date(form.end)).format('YYYY/MM/DD') : "",
  }

  const registRes = yield call(commons.post2, `/bg/systemControll/subHoliday`, newForm)

  const registCheck = yield call(errorCheck, registRes)
  if (!registCheck) {
    return
  }

  yield call(delay, 300)

  yield put(stopSubmit(`systemControllMasterForm`))

  yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
  yield put(actions.reducerAppLoading(false))

}

function* convertDate(list) {
  return list.map(x => {

    return {
      workHolidayAll: x.workHolidayAll ? moment(new Date(x.workHolidayAll)).format('YYYY/MM/DD') : "",
      workHolidayHarf: x.workHolidayHarf ? moment(new Date(x.workHolidayHarf)).format('YYYY/MM/DD'): "",
      subHoliday1: x.subHoliday1 ? moment(new Date(x.subHoliday1)).format('YYYY/MM/DD'): "",
      subHoliday2: x.subHoliday2 ? moment(new Date(x.subHoliday2)).format('YYYY/MM/DD') : "",
      comment: x.comment,
    }
  })
}



export function* handleSystemControllRoumuInit(action) {

    yield put(actions.reducerAppLoading(true))

    const branchOfficeRes = yield call(commons.get2, `/bg/master/branchOffice`)
    const branchOfficeResCheck = yield call(errorCheck, branchOfficeRes)
    if (!branchOfficeResCheck) {
        return
    }
    const departmentRes = yield call(commons.get2, `/bg/master/department`)
    const departmentResCheck = yield call(errorCheck, departmentRes)
    if (!departmentResCheck) {
        return
    }

    yield put(actions.reducerSystemControllRoumuInit(
        Object.assign({},
            {
                branchOffice: branchOfficeRes.result.list,
                department: departmentRes.result.list,
            }
        )))

  yield call(delay, 100)

  yield put(actions.reducerAppLoading(false))

}


function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`systemControllMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(stopSubmit(`systemControllMasterForm`))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`systemControllMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  if (res.error) {
    const { field, message } = res.error
    yield put(stopSubmit(`systemControllMasterForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
}


// WEBPACK FOOTER //
// ./src/sagas/systemControll.js